import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Scroll from "../Header/Scroll";
import Container from "../../common/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Image from "../../assets/images/lagoon.jpg";
import Details from "./components/Details";
import ContactHeader from "../Header/ContactHeader";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(0,0,95,0.5),rgba(0,0,95,0.5)), url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Advisory = () => {
  const theme = useTheme();
  return (
    <Box>
      <Helmet>
        <title> Our Advisory Council | Aquatic Hub Afrique</title>
      </Helmet>
      <Box
        bgcolor={"#194ec3"}
        position={"relative"}
        display={{ xs: "none", sm: "block" }}
      >
        <ContactHeader />
      </Box>
      <Scroll>
        <AppBar
          position={"sticky"}
          elevation={0}
          sx={{
            backgroundColor: theme.palette.background.paper,
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <Details />
        </Container>
      </Box>
      <Box bgcolor={"#000058"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Advisory;
